import { SensorDataFile, SensorDataFileRow } from "@shared/models";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  PaginatedResponse,
  ActionWithPayload,
  Filter,
  SensorDataFileValueFilter,
  WithCallback,
} from "@shared/interfaces";
import { startLoading, stopLoading } from "@shared/store/actions";
import { getPercentageFromFileUploading } from "@shared/utils";

import { createSensorDataFile, getSensorDataFiles, getSensorDataFile, getSensorDataFileValues } from "./actions";
import api from "../api";

function* getSensorDataFilesSaga({ payload }: ActionWithPayload<Filter>) {
  try {
    yield put(startLoading());
    const response: PaginatedResponse<SensorDataFile> = yield call(api.getSensorDataFiles, payload);
    yield put(stopLoading());
    yield put(
      getSensorDataFiles.success({
        ...response,
        is_clear: !payload.page,
      }),
    );
  } catch (error) {
    yield put(getSensorDataFiles.failure(error as Error));
    yield put(stopLoading());
  }
}

function* getSensorDataFileValuesSaga({ payload }: ActionWithPayload<SensorDataFileValueFilter & { id: number }>) {
  try {
    yield put(startLoading());
    const response: { rows: SensorDataFileRow[] } = yield call(api.getSensorDataFileValues, payload);
    yield put(stopLoading());
    yield put(getSensorDataFileValues.success(response));
  } catch (error) {
    yield put(getSensorDataFileValues.failure(error as Error));
    yield put(stopLoading());
  }
}

function* getSensorDataFileSaga({ payload }: ActionWithPayload<{ id: number }>) {
  try {
    yield put(startLoading());
    const response: SensorDataFile = yield call(api.getSensorDataFile, payload);
    yield put(stopLoading());
    yield put(getSensorDataFile.success(response));
  } catch (error) {
    yield put(getSensorDataFile.failure(error as Error));
    yield put(stopLoading());
  }
}

function* createSensorDataFileSaga({ payload }: ActionWithPayload<WithCallback<{ data: FormData }>>) {
  try {
    const { cb, data } = payload;
    yield put(startLoading());
    const response: SensorDataFile = yield call(
      api.createSensorDataFile,
      data,
      function getPercentage(progressEvent: { loaded: number; total: number }) {
        const percentage = getPercentageFromFileUploading(progressEvent);
        cb && cb(percentage);
      },
    );

    yield put(stopLoading());
    yield put(createSensorDataFile.success(response));
  } catch (error) {
    yield put(createSensorDataFile.failure(error as Error));
    yield put(stopLoading());
  }
}

function* SensorDataFileSaga() {
  yield takeLatest(getSensorDataFiles.request, getSensorDataFilesSaga);
  yield takeLatest(createSensorDataFile.request, createSensorDataFileSaga);
  yield takeLatest(getSensorDataFile.request, getSensorDataFileSaga);
  yield takeLatest(getSensorDataFileValues.request, getSensorDataFileValuesSaga);
}

export default SensorDataFileSaga;
